var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonwithiconDeleteModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.874997,
    y: 0.874997,
    width: 23.2496,
    height: 23.2496,
    rx: 2.62498,
    stroke: "#E03E2D",
    strokeWidth: 0.749994
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99997 7.49999C9.99997 6.80964 10.5596 6.25 11.25 6.25H13.7499C14.4403 6.25 14.9999 6.80964 14.9999 7.49999V8.74998H16.8685C16.8723 8.74994 16.8762 8.74994 16.8801 8.74998H17.4999C17.8451 8.74998 18.1249 9.0298 18.1249 9.37497C18.1249 9.72015 17.8451 9.99997 17.4999 9.99997H17.4569L16.9563 17.0085C16.8862 17.9897 16.0697 18.7499 15.086 18.7499H9.91387C8.93018 18.7499 8.11374 17.9897 8.04365 17.0085L7.54304 9.99997H7.49999C7.15482 9.99997 6.875 9.72015 6.875 9.37497C6.875 9.0298 7.15482 8.74998 7.49999 8.74998H8.11983C8.12371 8.74994 8.12758 8.74994 8.13144 8.74998H9.99997V7.49999ZM8.79622 9.99997L9.29047 16.9194C9.31383 17.2465 9.58598 17.4999 9.91387 17.4999H15.086C15.4139 17.4999 15.6861 17.2465 15.7094 16.9194L16.2037 9.99997H8.79622ZM13.7499 8.74998H11.25V7.49999H13.7499V8.74998ZM11.25 11.25C11.5951 11.25 11.875 11.5298 11.875 11.875V15.6249C11.875 15.9701 11.5951 16.2499 11.25 16.2499C10.9048 16.2499 10.625 15.9701 10.625 15.6249V11.875C10.625 11.5298 10.9048 11.25 11.25 11.25ZM13.7499 11.25C14.0951 11.25 14.3749 11.5298 14.3749 11.875V15.6249C14.3749 15.9701 14.0951 16.2499 13.7499 16.2499C13.4048 16.2499 13.1249 15.9701 13.1249 15.6249V11.875C13.1249 11.5298 13.4048 11.25 13.7499 11.25Z",
    fill: "#E03E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonwithiconDeleteModule);
export default __webpack_public_path__ + "static/media/Button with iconDeleteModule.285c8c7eb5615a59b2ded5b526ffd3de.svg";
export { ForwardRef as ReactComponent };